import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import ReactPlayer from 'react-player/lazy';
import { STATUS_COMPLETED } from 'utils/asset/getUserAssetStatus';
import { fillParent } from 'styles/mixins';
import useLocalStorage from 'hooks/useLocalStorage';
var StyledReactPlayer = styled(ReactPlayer).withConfig({
  displayName: "WebVideoPlayer__StyledReactPlayer",
  componentId: "sc-19exkfp-0"
})(["width:100%;height:100%;& iframe{", " width:100%;height:100%;}"], fillParent);
function WebVideoPlayer(_ref) {
  var src = _ref.src,
    autoCompleteEnabled = _ref.autoCompleteEnabled,
    userContentStatus = _ref.userContentStatus,
    onComplete = _ref.onComplete,
    onLoad = _ref.onLoad,
    onError = _ref.onError;
  var _useLocalStorage = useLocalStorage("web-video-progress-".concat(src)),
    _useLocalStorage2 = _slicedToArray(_useLocalStorage, 3),
    progress = _useLocalStorage2[0],
    setProgress = _useLocalStorage2[1],
    deleteProgress = _useLocalStorage2[2];
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    player = _useState2[0],
    setPlayer = _useState2[1];
  var hasMarkedAsDoneRef = useRef(false);
  function markAsDoneIfNecessary() {
    if (hasMarkedAsDoneRef.current) {
      return;
    }
    if (autoCompleteEnabled && userContentStatus !== STATUS_COMPLETED) {
      hasMarkedAsDoneRef.current = true;
      onComplete === null || onComplete === void 0 ? void 0 : onComplete();
    }
  }
  var hasStartedPlayingRef = useRef(false);
  function updateProgress(_ref2) {
    var played = _ref2.played,
      playedSeconds = _ref2.playedSeconds;
    if (!hasStartedPlayingRef.current) {
      return;
    }
    var newProgress = playedSeconds === null || playedSeconds === void 0 ? void 0 : playedSeconds.toFixed(); // round to the nearest second
    setProgress(newProgress || 0);

    // Mark a video as completed if we have watched at least 95%
    if (played >= 0.95) {
      markAsDoneIfNecessary();
    }
  }
  function deleteProgressAndMarkAsCompleted() {
    deleteProgress();
    markAsDoneIfNecessary();
  }
  function handlePlay() {
    if (hasStartedPlayingRef.current) {
      return;
    }
    hasStartedPlayingRef.current = true;

    // Resume video
    // Youtube videos will pause if we use player.seekTo
    // and we cannot force it to play programmatically hence using the player config's `playerVars`
    if (!src.includes('youtube') && player && progress) {
      player.seekTo(progress, 'seconds');
    }
  }
  return /*#__PURE__*/React.createElement(StyledReactPlayer, {
    ref: setPlayer,
    playing: false,
    url: src,
    controls: true,
    onReady: onLoad,
    onError: onError,
    onEnded: deleteProgressAndMarkAsCompleted,
    onProgress: updateProgress,
    onPlay: handlePlay,
    config: {
      youtube: {
        playerVars: {
          start: progress || 0
        }
      }
    }
  });
}
export default WebVideoPlayer;